<template>
  <unicom-linha :espacamento="false">
    <unicom-coluna sm="12" style="padding-bottom: 24px">
      <div class="titulo negrito cor-fonte fonte-primaria">
        Solicitação: <span class="cor-principal"> Anexos </span>
      </div>
      <div class="medio segunda-cor-fonte" style="padding-top: 12px">
        Solicitação de anexo. Para concluir, anexe o(s) arquivo(s) do tipo
        (.zip, .rar, .7z, .pdf, .png, .jpg, .jpeg).
      </div>
    </unicom-coluna>
    <unicom-coluna sm="12" :md="12" style="padding-right: 32px">
      <transition name="importador">
        <Importador
          class="importador"
          v-if="mostrarImportador"
          @arquivo="salvarArquivo"
        />
      </transition>
    </unicom-coluna>
    <unicom-coluna
      class="lista-arquivos"
      :class="{ aberto: mostrarImportador }"
      sm="12"
      :md="12"
    >
      <ListaArquivos
        :listaArquivos="listaArquivos"
        @baixar-arquivo="uuid => $emit('baixar-arquivo', uuid)"
        @arquivo-para-descricao="carregarArquivoParaDescricao"
      />
    </unicom-coluna>
  </unicom-linha>
</template>

<script>
import Importador from "./Importador/ImportadorAnexos.vue";
import ListaArquivos from "../ListaArquivos/ListaArquivos";
import SingularMixin from "./SingularMixin";
export default {
  mixins: [SingularMixin],
  components: {
    Importador,
    ListaArquivos
  },
  props: {
    listaArquivos: {
      type: Array,
      default: () => {
        return [
          // {
          //   "arquivo": "string",
          //   "baixavel": true,
          //   "dtAlteracao": "string",
          //   "dtUpload": "string",
          //   "id": 0,
          //   "status": {
          //     "chave": "PROCESSANDO",
          //     "descricao": "string"
          //   },
          //   "usuarioAlteracao": {
          //     "id": 0,
          //     "nome": "string"
          //   },
          //   "usuarioUpload": {
          //     "id": 0,
          //     "nome": "string"
          //   },
          //   "uuid": "string"
          // }
        ];
      }
    },
    podeEnviarArquivo: {
      type: Boolean
    }
  },
  computed: {
    mostrarImportador() {
      if (this.podeEnviarArquivo) {
        return true;
      }
      return false;
    }
  }
};
</script>

<style lang="scss" scoped>
.arquivo-vazio {
  background: #f1f2f1;
  margin: 0;
  height: 270px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  position: relative;
  width: 100%;
}

.importador {
  transition: all 0.3s ease-in-out;
}

.lista-arquivos {
  transition: all 0.3s ease-in-out;
  margin-left: auto;

  &.aberto {
    transition: none;
  }
}

// ANIMAÇÃO IMPORTADOR

.importador-enter,
.importador-leave-to {
  opacity: 0;
}

.importador-enter {
  transform: translateX(-90%);
}

.importador-leave-to {
  transform: translateX(-110%);
  transition: all 0.2s ease-in-out;
}

.importador-leave-active {
  position: absolute;
}
</style>
